// import React, { useEffect, useRef, useState } from 'react';
// import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
// import getIcon from '../../utils/getIcon';

// const SelectDropdown = ({ options, selectedOption, onSelectOption, className, defaultSelect }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [openUpwards, setOpenUpwards] = useState(false);
//     const [localSelectedOption, setLocalSelectedOption] = useState();
//     const ref = useRef()

//     const dropdownRef = useRef(null);
//     useEffect(() => {

//         if (defaultSelect) {
//             const defaultOption = options?.find(option =>
//                 String(option.value).toLowerCase() === String(defaultSelect).toLowerCase()
//             );

//             // const defaultOption = options?.find(option => option.value?.toLowerCase() === defaultSelect?.toLowerCase());
//             setLocalSelectedOption(defaultOption || null); // Set default if found
//         }

//         const handleClickOutside = (event) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setIsOpen(false);
//             }
//         };
//         document.addEventListener('click', handleClickOutside);

//         return () => {
//             document.removeEventListener('click', handleClickOutside);
//         };
//     }, [defaultSelect, options]);

//     const toggleDropdown = () => setIsOpen(!isOpen);

//     // const filteredOptions = options?.filter(option =>
//     //     option.label.toLowerCase().includes(searchTerm.toLowerCase())
//     // );

// const filteredOptions = options?.filter(option =>
//     option.label?.toLowerCase().includes(searchTerm.toLowerCase())
// );

//     useEffect(() => {
//         if (isOpen) {
//             const dropdown = dropdownRef.current;
//             const dropdownRect = dropdown.getBoundingClientRect();
//             const windowHeight = window.innerHeight;

//             if (dropdownRect.bottom + 200 > windowHeight) {
//                 setOpenUpwards(true);
//             } else {
//                 setOpenUpwards(false);
//             }
//         }
//     }, [isOpen]);
// useEffect(() => {
//     if (selectedOption) {
//         setLocalSelectedOption(selectedOption);
//     }
// }, [selectedOption]);

//     const handleOptionClick = (option) => {
//         onSelectOption(option);
//         setLocalSelectedOption(option);
//         setIsOpen(false);
//     };

//     return (
//         <div className={`select-dropdown ${className ? className : ""} ${openUpwards ? 'open-upwards' : ''}`} ref={dropdownRef}>
//             <div className={"select-box"} onClick={toggleDropdown}>
//                 <span className="selected-label">
//                     {localSelectedOption
//                         ? <>
//                             {localSelectedOption?.color && <span className="status-dot" style={{ backgroundColor: localSelectedOption?.color }}></span>}
//                             {localSelectedOption?.icon && <span className={`lh-1 fs-16 ${localSelectedOption.iconClassName}`}>{getIcon(localSelectedOption?.icon)}</span>}
//                             {localSelectedOption?.img && <img src={localSelectedOption.img} className="avatar-image avatar-sm" />}
//                             {localSelectedOption?.label}
//                         </>
//                         : <span className="text-muted">{defaultSelect || "Select an option"}</span>
//                     }
//                     {/* {localSelectedOption?.color ? <span className="status-dot" style={{ backgroundColor: localSelectedOption?.color }}></span> : ""}
//                     {localSelectedOption?.icon ? <span className={`lh-1 fs-16 ${localSelectedOption.iconClassName}`}>{getIcon(localSelectedOption?.icon)} </span> : ""}
//                     {localSelectedOption?.img ? <img src={localSelectedOption.img} className="avatar-image avatar-sm" /> : ""}
//                     {localSelectedOption?.label} */}
//                 </span>
//                 <span className="arrow">{isOpen ? <FiChevronUp /> : <FiChevronDown />}</span>
//             </div>

//             {isOpen && (
//                 <div className="dropdown-list">
//                     <div className='search-input-outer'>
//                         <input
//                             type="text"
//                             className="search-input"
//                             placeholder="Search..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                     </div>
//                     <ul>
//                         {filteredOptions.length > 0 ? (
//                             filteredOptions.map((option) => (
//                                 <li
//                                     key={option.value}
//                                     onClick={() => handleOptionClick(option)}
//                                     className={`${option?.value === localSelectedOption?.value ? 'active' : ''}`}
//                                 >
//                                     {option?.color ? <span className="status-dot" style={{ backgroundColor: option?.color }}></span> : ""}
//                                     {option?.icon ? <span className={`lh-1 me-3 fs-16 ${option.iconClassName}`}>{getIcon(option?.icon)}</span> : ""}
//                                     {option?.img ? <img src={option.img} className="avatar-image avatar-sm me-2" /> : ""}

//                                     {option?.label}
//                                 </li>
//                             ))
//                         ) : (
//                             <li className="no-result">No results found</li>
//                         )}
//                     </ul>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default SelectDropdown;

// // SelectDropdown.propTypes = {
// //     options: PropTypes.array.isRequired,
// //     defaultSelect: PropTypes.number,
// //     currentSelect: PropTypes.func
// // };

// // SelectDropdown.defaultProps = {
// //     currentSelect: () => { }
// // };

// import React from 'react';
// import getIcon from '../../utils/getIcon';

// const Select = ({ label, name, value, onChange, options, placeholder, icon }) => {
//   const IconComponent = icon ? getIcon(icon) : null;

//   return (
//     <div className="mb-4">
//       {label && <label className="form-label">{label}</label>}
//       <div className="input-group">
//         {IconComponent && (
//           <span className="input-group-text border-end-0">
//             {IconComponent}
//           </span>
//         )}
//         <select
//           name={name}
//           value={value}
//           onChange={(e) => onChange(name, e.target.value)}
//           className={`form-select ${IconComponent ? 'border-start-0' : ''}`}
//         >
//           <option value="">{placeholder || 'Select an option'}</option>
//           {options.map((opt) => (
//             <option key={opt.value} value={opt.value}>
//               {opt.label}
//             </option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );
// };

// export default Select;

import React, { useState, useEffect, useRef } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import getIcon from "../../utils/getIcon";

const SelectDropdown = ({
  options,
  selectedOption,
  onSelectOption,
  className,
  defaultSelect,
  label,
  name,
  value,
  onChange,
  placeholder,
  icon,
  required = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [openUpwards, setOpenUpwards] = useState(false);
  const [localSelectedOption, setLocalSelectedOption] = useState();
 
  const dropdownRef = useRef(null);

  const IconComponent = icon ? getIcon(icon) : null;

  // Default option selection based on the `defaultSelect` prop
  useEffect(() => {
    if (defaultSelect) {
      const defaultOption = options?.find(
        (option) =>
          String(option.value).toLowerCase() ===
          String(defaultSelect).toLowerCase()
      );
      setLocalSelectedOption(defaultOption || null); // Set default if found
    }
  }, [defaultSelect, options]);

  useEffect(() => {
    const filtered = options.filter((option) =>
      (option?.label || "")
        .toLowerCase()
        .includes((searchTerm || "").toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchTerm, options]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Handle option selection
  const handleOptionClick = (option) => {
    onSelectOption(option);
    setLocalSelectedOption(option);
    setIsOpen(false);
  };

  // Handle dynamic open/close based on dropdown position
  useEffect(() => {
    if (isOpen) {
      const dropdown = dropdownRef.current;
      const dropdownRect = dropdown.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (dropdownRect.bottom + 200 > windowHeight) {
        setOpenUpwards(true);
      } else {
        setOpenUpwards(false);
      }
    }
  }, [isOpen]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Search filtered options logic
  const filteredOptionsList = options?.filter((option) =>
    option.label?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className={`select-dropdown ${className ? className : ""} ${
        openUpwards ? "open-upwards" : ""
      }`}
      ref={dropdownRef}
    >
      {label && (
        <label className="selected-label">
          {label} :{required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}
      <div className="d-flex">
        {IconComponent && (
          <span className="input-group-text border-end-0">{IconComponent}</span>
        )}
        <div className="select-box w-100" onClick={toggleDropdown}>
          <span className="selected-label">
            {value ? (
              options.find((option) => option.value === value)?.label
            ) : (
              <span className="text-muted">
                {defaultSelect || "Select an option"}
              </span>
            )}
          </span>
          <span className="arrow">
            {isOpen ? <FiChevronUp /> : <FiChevronDown />}
          </span>
        </div>
      </div>

      {isOpen && (
        <div className="dropdown-list">
          <div className="search-input-outer">
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <ul>
            {filteredOptionsList.length > 0 ? (
              filteredOptionsList.map((option) => (
                <li
                  key={option.value}
                  onClick={() => handleOptionClick(option)}
                  className={`${option.value === value ? "active" : ""}`}
                >
                  {option.color && (
                    <span
                      className="status-dot"
                      style={{ backgroundColor: option.color }}
                    ></span>
                  )}
                  {option.icon && (
                    <span className={`lh-1 fs-16 ${option.iconClassName}`}>
                      {getIcon(option.icon)}
                    </span>
                  )}
                  {option.img && (
                    <img src={option.img} className="avatar-image avatar-sm" />
                  )}
                  {option.label}
                </li>
              ))
            ) : (
              <li className="no-result">No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SelectDropdown;
